export default "__VITE_ASSET__b349ee35__"